<template>
    <div class="order">
        <component :id="id" :is="type"></component>
    </div>
</template>
<script>
import PartnerOrder from '@/admin/modules/Order/_components/PartnerOrder.vue';
import UmiOrder from '@/admin/modules/Order/_components/UmiOrder.vue';

export default {
  props: ['id', 'type'],
  components: {
    PartnerOrder,
    UmiOrder,
  },
};
</script>
